import { usePurchaseContext } from '~/purchase/context';
import { invariant, useOnMount } from '@wyz/utils';
import { IQuote } from '~/purchase/types';
// eslint-disable-next-line @wyz/module/invalid-import
import {
  ExpandedRowServicesOnly,
  ExpandedRowWithTyres,
} from '~/purchase/components/quote';
import { useAnalytics, useConfig } from '~/common/context';
import { useAuth } from 'react-oidc-context';
import { IQuoteOpenedEvent } from '~/common/types';
import { isNil } from 'lodash-es';

const ExpandedRow = ({ quote }: { quote: IQuote }) => {
  const { state } = usePurchaseContext();
  const selectedCustomer = state.targetCustomer;
  invariant(selectedCustomer);
  const { tenantCode } = useConfig();
  const auth = useAuth();
  const { sendEvent } = useAnalytics();

  useOnMount(() => {
    const event = {
      type: 'Quote opened',
      backend: 'business_event_logger',
      level: 'info',
      message: `Quote with reference ${quote.reference} opened`,
      source: 'WTB2',
      target: 'WTB2',
      data: {
        quoteId: quote.id,
        clientCode: selectedCustomer.code,
        platformCode: tenantCode,
        diagId: isNil(quote.diagnosisId) ? null : quote.diagnosisId,
      },
    } satisfies IQuoteOpenedEvent;
    sendEvent(auth.user, event);
  });

  if (!quote.tyres) {
    return (
      <ExpandedRowServicesOnly
        quote={quote}
        selectedCustomerCode={selectedCustomer.code}
      />
    );
  }

  return (
    <ExpandedRowWithTyres quote={quote} selectedCustomer={selectedCustomer} />
  );
};

export default ExpandedRow;
